import { render, staticRenderFns } from "./fileArchive.vue?vue&type=template&id=4eccf2d4&scoped=true"
import script from "./fileArchive.vue?vue&type=script&lang=js"
export * from "./fileArchive.vue?vue&type=script&lang=js"
import style0 from "./fileArchive.vue?vue&type=style&index=0&id=4eccf2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eccf2d4",
  null
  
)

export default component.exports